import { ROLLOVER_DATA_RECEIVED, ROLLOVER_DATA_UNLOADED } from './types';

export default function rollover(state = [], action = {}){
  switch (action.type) {
    case ROLLOVER_DATA_RECEIVED:
      return action.data
    case ROLLOVER_DATA_UNLOADED:
      return []
    default:
      return state;
  }
}
